import { MultiTenancyProfile } from './multi-tenancy-profile.enum';
import { MultiTenancyEndpoint } from './multi-tenancy-endpoint.service';
import { HttpRequest } from '../../../core';

export class SingleTenantEndpoint extends MultiTenancyEndpoint {
  constructor(
    contextPath: string,
    public readonly profile: MultiTenancyProfile = MultiTenancyProfile.DE
  ) {
    super(contextPath, profile);
    this._rootPath = contextPath;
  }

  /**
   * Set active profile and create a new root path.
   *
   */
  public override setActive(profile: MultiTenancyProfile) {
    // nothing to do
  }

  /**
   * Get active profile
   */
  override get activeProfile(): MultiTenancyProfile {
    return this.profile;
  }

  /**
   * Hacking for Partners. Partners resource is common for all tenancies.
   *
   */
  override getRoot(request: HttpRequest): string {
    return super.getRoot(request);
  }
}
